// DataTableRow.tsx

import { Box } from '@mui/material'
import React from 'react'
import { TableCellDataGetter, TableCellRenderer, TableRowProps, TableRowRenderer } from 'react-virtualized'

export interface ITableColumnProps extends TableRowRenderer {
  cellDataGetter?: TableCellDataGetter
  cellRenderer?: TableCellRenderer
  dataKey: string
  label: string
  width: number
}

export default function TableRow({ key, style, columns, ...props }: TableRowProps) {
  return (
    <Box
      key={key}
      {...props}
      sx={{
        ...style,
        fontSize: '12px',
        lineHeight: '16px',
        backgroundColor: props.index % 2 === 0 ? 'table.oddLineBackground' : 'table.evenLineBackground',
      }}
    >
      {columns}
    </Box>
  )
}
